import React from 'react'
import Requisiciones from '../components/Requisiciones'

const requisiciones = () => {
  return (
    <Requisiciones />
  )
}

export default requisiciones